import { createContext, useContext, useLayoutEffect } from "react";

export const ScheduledBriefingsFullscreenContext = createContext<
  (isFullscreen: boolean) => void
>(() => {});

/** Hides the Scheduled Briefings tab bar while the calling workflow page is mounted. */
export const useScheduledBriefingsFullscreen = () => {
  const setIsFullscreen = useContext(ScheduledBriefingsFullscreenContext);

  // Layout effect so the tab bar never paints above the workflow header.
  useLayoutEffect(() => {
    setIsFullscreen(true);
    return () => setIsFullscreen(false);
  }, [setIsFullscreen]);
};
